import type { PaletteMode } from '@mui/material';

import { authToolkit } from '/store/toolkits/auth';
import { getUrlAppName, parseJSON } from '/helpers';
import { preferredThemeModeLocalStorageKey } from '/constants/themeConstants';
import { startAppListening } from '/store/listenerMiddleware';

import { IUIState, uiToolkit, uiInitialState } from './ui';

function getInitUIState(userID: string): IUIState {
  const persistedThemeModelessUI: string | null = localStorage.getItem(`ui:${userID}`);
  const persistedThemeMode = localStorage.getItem(preferredThemeModeLocalStorageKey) as PaletteMode;

  if (!persistedThemeModelessUI) {
    return uiInitialState;
  }

  try {
    const uiState = parseJSON<undefined | IUIState>(persistedThemeModelessUI);
    if (!uiState) {
      return uiInitialState;
    }

    uiState.currentThemeMode = persistedThemeMode;
    return uiState;
  } catch (e) {
    console.error(`Can't read ui state from localStorage`, e);

    return uiInitialState;
  }
}

export const initListeners = () => {
  startAppListening({
    actionCreator: authToolkit.actions.rehydrate,
    effect: async (action, api) => {
      const urlAppName = getUrlAppName(window.location.pathname);
      const isLoginPage = window.location.pathname.includes('login');

      const userID = action.payload.user.id;
      const uiState = getInitUIState(userID);

      if (!isLoginPage && !urlAppName) {
        uiState.timeline.open = false;
      }

      api.dispatch(uiToolkit.actions.update(uiState));
    },
  });
};
